import { ContactModel, RelationshipCategory, RelationshipType } from '../../../../core/lists';
import { DocType, ReviewMode } from '../enums';
import { Entity } from './entity.model';
import { Category } from './category.model';

export class Document {
  constructor(
    public id = 0,
    public entity_id = 0,
    public reference_id = '',
    public type: DocType = null,
    public category: Category = null,
    public name = '',
    public description = '',
    public file_base64 = '',
    public url = '',
    public entities: Entity[] = null,
    public relation_categories: RelationshipCategory[] = null,
    public relation_types: RelationshipType[] = null,
    public phi = false,
    public patient_only = false,
    public mobile_visible = false,
    public requires_review = false,
    public primary_reviewer = false,
    public review_mode: ReviewMode = null,
    public contact_reviewers: ContactModel[] = null,
    public review_by_date = '',
    public visible_after = '',
    public expire_after = '',
    public reviewed = false,
    public reviewed_by_id = 0,
    public reviewed_by: ContactModel = null,
    public uploaded_by_id = 0,
    public uploaded_by = '',
    public upload_date = '',
    public uploader_type = 'USER',
    public source = 'KNOSTOS',
  ) {}
}
